import React from "react";
import Container from "../components/Container";
import SideBar from "../components/SideBar";
import TasksList from "../components/TasksList";

export default function Home() {
  return (
    <>
      <Container>
        <SideBar />
        <TasksList />
      </Container>
    </>
  );
}
